<template>
  <v-list nav dense>
    <template>
      <v-list-item link router to="/home" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('inicio') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group prepend-icon="mdi-golf" no-action color="white">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Golf</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link router to="/golf/caddies" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-account-tie</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('golf_caddies') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/courts" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-soccer-field</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('golf_courts') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/blacklist" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-account-cancel</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('golf_blacklist') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/reservations" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-calendar-clock</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('golf_reservations') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/caddie-house" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-package-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Caddie House
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/garage" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-car</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Garaje de Carritos
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-item link router to="/golf/tournaments" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-tournament</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('golf_tournaments') || 'Torneos' }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link router to="/golf/kids-tournament-families" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-account-group</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Familias Torneo Infantil
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group prepend-icon="mdi-chart-box" no-action color="white">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Estadísticas de Golf</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link router to="/golf/scorecards" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-chart-line</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('golf_scorecards') || 'Scorecards' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/handicaps" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-calculator</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('golf_handicaps') || 'Handicaps' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/players-summary" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('golf_players_summary') || 'Resumen de Jugadores' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-group prepend-icon="mdi-school" no-action color="white">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Academia</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link router to="/academy" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-view-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Panel Principal</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/academy/teachers" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-account-tie</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Profesores</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/academy/clinics" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-calendar-clock</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Clínicas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/academy/students" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Alumnos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-group prepend-icon="mdi-handshake" no-action color="white">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Convenios de Golf</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link router to="/golf/convenios" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-plus-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Generar Nuevo Convenio
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/convenios/listado" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-list-box</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Listado de Convenios
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/convenios/tipos" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-tag-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Tipos de Convenios
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/convenios/campos" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-golf</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Campos Disponibles
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'golf_public_relations'
}
</script>
